import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      {/* Diagonal Transparent Background Logo */}
      <div className="footer-bg-logo">
        <svg viewBox="0 0 400 180" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <text x="50" y="100" textAnchor="middle" fontFamily="'Playfair Display', serif" fontSize="85" fontWeight="800" fill="#ffffff">
            EL
          </text>
          <text x="230" y="80" textAnchor="middle" fontFamily="'Playfair Display', serif" fontSize="75" fontWeight="800" fill="#ffffff">
            EDZURE
          </text>
          <text x="230" y="150" textAnchor="middle" fontFamily="'Playfair Display', serif" fontSize="55" letterSpacing="6" fill="#ffffff">
            LEGAL
          </text>
        </svg>
      </div>

      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-logo">
            <div className="nav-monogram-container">
              <div className="nav-monogram-outer-ring"></div>
              <div className="nav-monogram-divider"></div>
              <span className="nav-monogram-text">EL</span>
              <div className="nav-monogram-divider"></div>
            </div>

            <svg className="footer-logo-name" width="100" height="40" viewBox="100 0 300 180" xmlns="http://www.w3.org/2000/svg" aria-label="EdZure Legal">
              <defs>
                <linearGradient id="gold-footer" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#f3d38b" />
                  <stop offset="100%" stopColor="#b8860b" />
                </linearGradient>
              </defs>

              <text x="200" y="80" textAnchor="middle" fontFamily="'Playfair Display', serif" fontSize="72" fontWeight="700" fill="#ffffff">
                EDZURE
              </text>

              <text x="200" y="150" textAnchor="middle" fontFamily="'Playfair Display', serif" fontSize="54" letterSpacing="5" fill="url(#gold-footer)">
                LEGAL
              </text>
            </svg>
          </div>
          <p>Professional legal services with expertise and integrity.</p>
          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/in/edzure-legal-associate-041626254/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="LinkedIn"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                <rect x="2" y="9" width="4" height="12"></rect>
                <circle cx="4" cy="4" r="2"></circle>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/insights">Insights</Link></li>
            <li><Link to="/legal-disclaimer">Legal Disclaimer</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li><Link to="/area-of-practice">Areas of Practice</Link></li>
            <li><Link to="/careers">Careers</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <ul>
            <li className="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
              <span>edzurelegalllp@gmail.com</span>
            </li>
            <li className="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
              <span>+91-7389892992, +91-7987103426</span>
            </li>
            <li className="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              <span>62, Supreme Enclave Mayur Vihar Phase I, New Delhi 110092</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-copyright-wrap" style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <p>&copy; {currentYear} EdZure Legal LLP. All rights reserved.</p>
          <p style={{ fontSize: '0.85rem', opacity: 0.75, margin: 0 }}>Crafted by Anmol Chaudhary</p>
        </div>
        <button onClick={scrollToTop} className="back-to-top-btn" aria-label="Back to top">
          Back to Top
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
        </button>
      </div>
    </footer>
  );
};

export default Footer;